<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="'Сохранить'"
		:isDontNeedCloseWhenSave="true"
		@save="saveHandler"
		height="calc(100% - 145px)"
		min-height-body="unset"
		:is-loading-btn-save="props.isLoading"
		:is-need-cancel-btn="
			!driverRequestsStore.loading.getCargoById && (currentCargo?.allowedNextStatuses?.length || 0) == 0
		"
		:isNeedBtnSave="!driverRequestsStore.loading.getCargoById && !currentCargo?.allowedNextStatuses?.length"
	>
		<TypographyKTypographyBody2
			color="var(--color_font_black_wite)"
			font-type="bold"
		>
			{{ $t('Информация о грузе') }}
		</TypographyKTypographyBody2>
		<div class="wrapper">
			<div
				class="content"
				v-if="currentCargo && !driverRequestsStore.loading.getCargoById"
			>
				<PagesCargosCardInfo
					:request="currentCargo"
					:isNeedMoreInfo="true"
					:isNeedStatusCargo="false"
				/>
				<div class="content__checkbox card">
					<UiCheckBox v-model="checkBoxInfoCargo.documentAreMissing">
						<TypographyKTypographyBody5 color="var(--dark-primary)">{{
							'Полное отсутствие документов'
						}}</TypographyKTypographyBody5>
					</UiCheckBox>
					<UiCheckBox v-model="checkBoxInfoCargo.allDocuments">
						<TypographyKTypographyBody5 color="var(--dark-primary)">{{
							'Есть все документы'
						}}</TypographyKTypographyBody5>
					</UiCheckBox>
					<UiCheckBox v-model="checkBoxInfoCargo.naklOnly">
						<TypographyKTypographyBody5 color="var(--dark-primary)">{{
							'Только накладные'
						}}</TypographyKTypographyBody5>
					</UiCheckBox>
					<UiCheckBox v-model="checkBoxInfoCargo.cmrOnly">
						<TypographyKTypographyBody5 color="var(--dark-primary)">{{ 'Только CRM' }}</TypographyKTypographyBody5>
					</UiCheckBox>
				</div>
				<div class="content__comments card">
					<div class="content__comments_hader">
						<TypographyKTypographyBody4 font-type="medium">
							{{ 'Габариты' }}
						</TypographyKTypographyBody4>
						<UiButton
							:color="ButtonType.primary"
							:size="ButtonSizeType.medium"
							@click="openAddedSizeModal"
						>
							<UiIcon
								name="message-question"
								folder="cargos"
								width="20px"
								height="20px"
								color="var(--white)"
							/>
							<TypographyKTypographyBody5>
								{{ currentCargo?.size ? 'Изменить' : 'Добавить' }}
							</TypographyKTypographyBody5>
						</UiButton>
					</div>
					<TypographyKTypographyBody5
						font-type="regular"
						color="var(--dark-primary)"
					>
						<span v-html="currentCargo?.size"></span>
					</TypographyKTypographyBody5>
				</div>
				<div class="content__comments card">
					<div class="content__comments_hader">
						<TypographyKTypographyBody4 font-type="medium">
							{{ 'Все комментарии' }}
						</TypographyKTypographyBody4>
						<UiButton
							:color="ButtonType.primary"
							:size="ButtonSizeType.medium"
							@click="openAddedCommentModal"
						>
							<UiIcon
								name="message-question"
								folder="cargos"
								width="20px"
								height="20px"
								color="var(--white)"
							/>
							<TypographyKTypographyBody5>
								{{ 'Добавить' }}
							</TypographyKTypographyBody5>
						</UiButton>
					</div>
					<div class="content__comments_content">
						<div class="wrapper">
							<div
								class="item"
								v-for="comment in currentCargo.cargoComments"
								:key="comment.id"
							>
								<div class="item-text">
									<TypographyKTypographyBody6 color="var(--gray-secondary)">
										{{ getDateInLocaleString(comment.dtCreate) }}
									</TypographyKTypographyBody6>
									<TypographyKTypographyBody5 color="var(--gray-new-2)">
										{{ comment.text }}
									</TypographyKTypographyBody5>
								</div>
								<UiButtonIcon
									padding="2px"
									background="transparent"
									@click="deleteCommentHandler(comment)"
								>
									<UiIcon
										name="delete"
										width="18px"
										height="18px"
									/>
								</UiButtonIcon>
							</div>
						</div>
					</div>
				</div>
				<div class="content__images">
					<UiButtonFile
						:color="ButtonType.primary"
						:size="ButtonSizeType.medium"
						:label="'Добавить фото'"
						:isMultiple="true"
						@load="uploadNewFile"
					>
						<UiIcon
							name="camera"
							folder="cargos"
							width="20px"
							height="20px"
							color="var(--white)"
						/>
					</UiButtonFile>
					<div
						class="images"
						v-if="currentCargo.cargoImages?.length"
					>
						<div
							class="image"
							v-for="(image, index) in currentCargo.cargoImages"
						>
							<UiImage
								lazy="lazy"
								:src="image.urlPreview"
								@click.stop="openModalInFullSize(index)"
							/>
							<UiButtonIcon
								background="var(--white)"
								padding="4px"
								class="btn_remove"
								@click="deleteImageHandler(image)"
							>
								<UiIcon
									name="remove"
									folder="button"
									width="19px"
									height="19px"
								/>
							</UiButtonIcon>
						</div>
						<div class="loader-wrapper">
							<UiLoader
								v-if="cargoImageStore.loading.addCargoImage"
								class="ui-loader"
								:circle-width="2"
								:radius="14"
								:color="'var(--bg-primary)'"
							/>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="loader"
			>
				<UiLoaderLottie />
			</div>
		</div>
		<template
			#custom-actions
			v-if="currentCargo?.allowedNextStatuses?.length"
		>
			<div
				class="actions-btn"
				:class="{
					'actions-btn__grid-3': currentCargo?.allowedNextStatuses?.length >= 3,
					'actions-btn__grid-1': currentCargo?.allowedNextStatuses?.length >= 1
				}"
			>
				<UiButton
					v-for="btn in currentCargo?.allowedNextStatuses"
					:size="ButtonSizeType.b_xl"
					colorSpinner="linear-gradient(90deg, rgba(0, -1, 0, 0.05), rgba(0, 0, 0, 0.15))"
					class="btn"
					:style="{ backgroundColor: pickupStatusesComp?.get(btn)?.backgroundColor }"
					@click="saveHandler(btn)"
					:key="btn"
				>
					<TypographyKTypographyBody4
						:color="pickupStatusesComp?.get(btn)?.fontColor"
						font-type="bold"
						>{{ pickupStatusesComp?.get(btn)?.btnTitle }}</TypographyKTypographyBody4
					>
				</UiButton>
			</div>
		</template>
	</UiModalMobile>
	<PagesCargosAddedCommentModal
		:currentCargo="currentCargo"
		:isLoading="cargoCommentStore.loading?.addCargoComment"
		v-model="isCommentModalOpen"
		v-if="isCommentModalOpen"
		@save="saveAddedModalHandler"
		:z-index="10000"
	/>
	<PagesCargosAddedSizeModal
		:currentCargo="currentCargo"
		:isLoading="loading.saveSize"
		v-model="isSizeModalOpen"
		v-if="isSizeModalOpen"
		@save="saveAddedSizeModalHandler"
		:z-index="10000"
	/>
	<UiModalConfirm
		v-if="isOpenConfirmDeleteCommentModal"
		v-model="isOpenConfirmDeleteCommentModal"
		title="Вы уверены, что хотите удалить комментарий?"
		:is-need-save-btn="true"
		@save="confirmDeleteCommentHandler"
	/>
	<UiModalConfirm
		v-if="isOpenConfirmDeleteImageModal"
		v-model="isOpenConfirmDeleteImageModal"
		title="Вы уверены, что хотите удалить изображение?"
		:is-need-save-btn="true"
		@save="confirmDeleteImageHandler"
	/>
	<UiModalImagesModal
		v-if="isOpenModalFullScreenImage"
		:initial-index="initialIndexImage"
		v-model="isOpenModalFullScreenImage"
		:images="listImages"
	/>
</template>

<script setup lang="ts">
	import { getDateInLocaleString } from '~/helpers/date';
	import { VALIDATE_RULES, validator } from '~/helpers/validate';
	import { useCargoCommentStore } from '~/store/cargoComment.store';
	import { useCargoImageStore } from '~/store/cargoImage.store';
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import { useDriverRequestStore } from '~/store/driverRequests.store';
	import type { ICargoCommentAddResponse } from '~~/shared/interfaces/cargoComment';
	import type { ICargoComment, ICargoImage } from '~~/shared/interfaces/driverRequests';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['save']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			currentCargoId: string;
			isLoading?: boolean;
		}>(),
		{}
	);

	const cargoCommentStore = useCargoCommentStore();
	const driverRequestsStore = useDriverRequestStore();
	const dictionariesStrore = useDictionariesStore();
	const cargoImageStore = useCargoImageStore();
	const pickupStatusesComp = computed(() => dictionariesStrore.pickupStatuses);
	const isModelOpenAndLoadedData = ref(false);
	const isCommentModalOpen = ref(false);
	const isSizeModalOpen = ref(false);
	const isOpenConfirmDeleteCommentModal = ref(false);
	const currentComment = ref<ICargoComment | null>(null);
	const isOpenConfirmDeleteImageModal = ref(false);
	const currentImage = ref<ICargoImage | null>(null);
	const initialIndexImage = ref<number | null>(null);
	const isOpenModalFullScreenImage = ref(false);
	const loading = reactive({
		saveSize: false
	});

	const listImages = computed(() => {
		return (
			currentCargo.value?.cargoImages.map((i) => {
				return { preview: i.urlPreview, url: i.urlOriginal };
			}) || []
		);
	});

	const currentCargo = computed(() => {
		if (!isModelOpenAndLoadedData.value && driverRequestsStore.currentCargo?.id) {
			checkBoxInfoCargo.allDocuments = driverRequestsStore.currentCargo.cargoPickupDetail.allDocuments || false;
			checkBoxInfoCargo.documentAreMissing =
				driverRequestsStore.currentCargo.cargoPickupDetail.documentAreMissing || false;
			checkBoxInfoCargo.naklOnly = driverRequestsStore.currentCargo.cargoPickupDetail.naklOnly || false;
			checkBoxInfoCargo.cmrOnly = driverRequestsStore.currentCargo.cargoPickupDetail.cmrOnly || false;

			isModelOpenAndLoadedData.value = true;
		}

		return driverRequestsStore.currentCargo;
	});
	const checkBoxInfoCargo = reactive({
		documentAreMissing: false,
		naklOnly: false,
		cmrOnly: false,
		allDocuments: false
	});
	const errorField = ref({
		text: { status: false, msg: '' }
	});

	const openModalInFullSize = (index: number) => {
		initialIndexImage.value = index;
		setTimeout(() => {
			isOpenModalFullScreenImage.value = true;
		});
	};

	const saveAddedSizeModalHandler = async (payload: { size: string }) => {
		const saveSize = driverRequestsStore?.currentCargo?.size;
		driverRequestsStore.currentCargo = { ...driverRequestsStore.currentCargo, size: payload?.size };

		loading.saveSize = true;
		const response = await driverRequestsStore.savePickupDetails({
			query: { status: driverRequestsStore.currentCargo?.cargoPickupDetail?.cargoPickupStatusId },
			body: {
				size: currentCargo.value?.size,
				cargoId: currentCargo.value?.id || ''
			}
		});

		if (response.status === 'success') {
			closeAddedSizeModal();
		} else {
			driverRequestsStore.currentCargo = { ...driverRequestsStore.currentCargo, size: saveSize };
		}
		loading.saveSize = false;
	};

	const openAddedSizeModal = () => {
		isSizeModalOpen.value = !isSizeModalOpen.value;
	};
	const closeAddedSizeModal = () => {
		isSizeModalOpen.value = false;
	};

	const openAddedCommentModal = () => {
		isCommentModalOpen.value = !isCommentModalOpen.value;
	};

	const getCargoById = async (isNeedLoad = true) => {
		await driverRequestsStore.getCargoById({ id: props.currentCargoId }, isNeedLoad);
	};

	const saveAddedModalHandler = async (payload: ICargoCommentAddResponse) => {
		const response = await cargoCommentStore.addCargoComment(payload);

		if (response.status) {
			getCargoById(false);
			isCommentModalOpen.value = false;
		}
	};

	const deleteCommentHandler = (cargoComment: ICargoComment) => {
		currentComment.value = cargoComment;
		setTimeout(() => {
			isOpenConfirmDeleteCommentModal.value = true;
		});
	};

	const confirmDeleteCommentHandler = async () => {
		const saveId = currentComment.value!.id;
		const response = await cargoCommentStore.cargoCommentDelete({ id: saveId });

		if (response.status) {
			driverRequestsStore.deleteCurrentCargoComment({ id: saveId });
			isOpenConfirmDeleteCommentModal.value = false;
		}
	};

	const deleteImageHandler = async (image: ICargoImage) => {
		currentImage.value = image;
		setTimeout(() => {
			isOpenConfirmDeleteImageModal.value = true;
		});
	};

	const confirmDeleteImageHandler = async () => {
		const saveId = currentImage.value!.id;
		const response = await cargoImageStore.cargoImageDelete({ id: saveId });

		if (response.status) {
			driverRequestsStore.deleteCurrentCargoImage({ id: saveId });
			isOpenConfirmDeleteImageModal.value = false;
		}
	};

	const uploadNewFile = async (file: { file: File }[]) => {
		const response = await cargoImageStore.uploadCargoImage({
			cargoId: props.currentCargoId,
			files: file.map((f) => f.file),
			cargoImageType: 'Pickup'
		});

		if (response.status) {
			getCargoById(false);
		}
	};

	const saveHandler = async (status: string) => {
		const response = await driverRequestsStore.savePickupDetails({
			query: { status: status },
			body: {
				allDocuments: checkBoxInfoCargo.allDocuments,
				cmrOnly: checkBoxInfoCargo.cmrOnly,
				documentAreMissing: checkBoxInfoCargo.documentAreMissing,
				naklOnly: checkBoxInfoCargo.naklOnly,
				size: currentCargo.value?.size,
				cargoId: currentCargo.value?.id || ''
			}
		});

		if (response.status === 'success') {
			setTimeout(() => {
				driverRequestsStore.getHeaderInfo();
			}, 100);
		}
		modelValue.value = false;
	};

	getCargoById();

	onUnmounted(() => {
		driverRequestsStore.resetCurrentCargo();
	});
</script>

<style scoped lang="scss">
	.modal__mobile {
		display: flex;
		flex-direction: column;

		.actions-btn {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 10px;

			&__grid-3 {
				grid-template-columns: 1fr;
			}
			&__grid-1 {
				grid-template-columns: 1fr;
			}
		}

		.content {
			.card {
				padding: 14px 14px;
				background-color: var(--gray-primary);
				border-radius: 12px;
			}

			&__images {
				display: flex;
				flex-direction: column;
				margin-top: 14px;
				margin-bottom: 6px;

				.images {
					display: flex;
					flex-wrap: wrap;
					gap: 15px;
					overflow: auto;
					max-height: 180px;
					padding: 4px;
					margin-top: 12px;
					margin-bottom: 10px;

					.image {
						position: relative;
						width: 76px;
						height: 76px;
						min-width: 76px;
						background-repeat: no-repeat;
						background-position: center;
						background-size: cover;
						border-radius: 12px;
						box-shadow: 0px 0px 5.6px 0px #0000001f;
						margin: 2px 0px;

						img {
							width: 76px;
							height: 76px;
							border-radius: 12px;
						}

						.btn_remove {
							position: absolute;
							top: -9px;
							right: -9px;
						}
					}

					.loader-wrapper {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 76px;
						height: 76px;

						.ui-loader {
							width: 100%;
							height: 100%;
							margin: auto;
						}
					}
				}

				.ui-file {
					margin-left: auto;
				}
			}

			&__comments {
				margin-top: 12px;

				&_content {
					margin-top: 10px;

					.wrapper {
						display: flex;
						flex-direction: column;
						gap: 10px;
						max-height: 120px;
						min-height: 30px;
						overflow: auto;
						padding: 2px 0px;
					}

					.item {
						display: flex;
						justify-content: space-between;
						align-items: center;

						&-text {
							display: flex;
							flex-direction: column;
							gap: 0px;
						}
					}
				}

				&_hader {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
			}

			&__checkbox {
				display: flex;
				flex-direction: column;
				gap: 10px;
				margin-top: 12px;
			}
		}

		.loader {
			margin: auto;
		}

		.label-select {
			margin-left: auto;
		}

		.upper-limit-clue {
			max-width: 300px;
			@media (max-width: $sm) {
				max-width: 200px;
			}
		}

		.input__secret {
			display: flex;
			flex-direction: column;
			gap: 8px;
			margin-bottom: -10px;
		}

		.wrapper {
			display: flex;
			flex-direction: column;
			overflow: auto;
			height: 100%;
			gap: 17px;
			margin-top: 14px;
			padding-right: 10px;
			margin-right: -10px;

			.switch-wrapper {
				margin-top: 0px;
				display: flex;
				align-items: center;
				gap: 14px;
			}
		}
	}
</style>
